import { z } from 'zod'

import { zPriceValue } from '@/schemas/priceValueSchema'

export const zProductPrice = z.object({
  productId: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[0-9a-zA-Z_-]{1,255}$/),
  quantity: z.int(),
  price: z.nullable(zPriceValue),
})

export type ProductPriceSchema = z.infer<typeof zProductPrice>
